import {ApiV0} from "../api.v0";
import {RestApiService} from "../../rest-api.service";
import {Observable} from "rxjs";
import {LoginReq, LoginRes} from "../../../contracts/v0/cp";

export class ApiV0Auth {
    segment = '/auth';

    constructor(
        v0: ApiV0,
        private rest: RestApiService,
    ) {
        this.segment = v0.segment + this.segment;
    }

    login(dto: LoginReq): Observable<LoginRes> {
        return this.rest.post<LoginReq, LoginRes>(`${this.segment}/login`, LoginRes, dto);
    }

    loginWithRefreshToken(refreshToken?: string): Observable<LoginRes> {
        return this.rest.post(`${this.segment}/refreshToken`, LoginRes, refreshToken);
    }
}
